// product page width set script 

(function() {

    // --- The core logic that adds the classes ---
    function runMyLogic($) {
        // Target both containers
        $('.pageCollection__header, .collection-description').each(function() {
            // Find all <p> descendants inside this container
            $(this).find('p').each(function() {
                var $p = $(this);

                // --- CONDITION 1: Must have NO class attribute ---
                if ($p.attr('class')) {
                    return; // skip this <p>
                }

                // --- CONDITION 2: Check for "only image inside" ---
                // Exactly 1 child node, that child is an <img>, and no extra text nodes
                if ($p.children().length === 1 && 
                    $p.children('img').length === 1 && 
                    $p.contents().length === 1) {
                    
                    $p.addClass('collection-description-p-image');
                    return; // done with this <p>
                }

                // --- NEW CONDITION 3: Check for "<p><span>text</span></p>" ---
                // Exactly 1 child node, that child is a <span>, and no extra text nodes
                if ($p.children().length === 1 && 
                    $p.children('span').length === 1 && 
                    $p.contents().length === 1) {
                    
                    var $span = $p.children('span');
                    
                    // The <span> itself must have NO class attribute
                    if (!$span.attr('class')) {
                        // The <span> must have NO child elements (only plain text)
                        if ($span.children().length === 0) {
                            var text = $span.text().trim();
                            
                            // Text must not be empty and must not be the word "image"
                            if (text !== '' && text.toLowerCase() !== 'image') {
                                $p.addClass('collection-description-paragraph');
                            }
                        }
                    }
                    return; // done with this <p>
                }

                // --- CONDITION 4: Check for "only plain text inside <p>" ---
                // No child elements at all (only text nodes directly inside <p>)
                if ($p.children().length === 0) {
                    var text = $p.text().trim();
                    
                    // Text must not be empty and must not be the word "image"
                    if (text !== '' && text.toLowerCase() !== 'image') {
                        $p.addClass('collection-description-paragraph');
                    }
                    return; // done with this <p>
                }

                // If we reach here, the <p> has other elements or mixed content → skip
            });
        });
    }

    // --- The function that starts everything ---
    function init() {
        // If jQuery is missing, load it from CDN first
        if (typeof jQuery === 'undefined') {
            console.warn('jQuery not found. Dynamically loading it now...');
            var script = document.createElement('script');
            script.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
            script.onload = function() {
                // Once loaded, wait for DOM and run
                jQuery(document).ready(function($) {
                    runMyLogic($);
                });
            };
            script.onerror = function() {
                console.error('Failed to load jQuery. Please check your internet connection.');
            };
            document.head.appendChild(script);
        } else {
            // jQuery exists, just wait for DOM and run
            jQuery(document).ready(function($) {
                runMyLogic($);
            });
        }
    }

    // --- Wait for the page DOM to be ready before checking ---
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    /* Move Addto cartbutton */
    // Move Quantity and Add to Cart button
function moveQtyAndButton() {
    const qty = document.querySelector('[data-block-type="quantity-selector"]');
    const buyButtonsElement = document.querySelector('buy-buttons');
    const giftWrap = document.querySelector('.hulkapps_option_set');

    if (!qty || !buyButtonsElement || !giftWrap) {
        return false;
    }

    // Prevent duplicate wrapper creation
    let wrapper = document.querySelector('.atc-row');

    if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'atc-row';

        const buyButtonsParent = buyButtonsElement.parentNode;

        if (buyButtonsParent && buyButtonsParent.parentNode) {
            buyButtonsParent.parentNode.insertBefore(
                wrapper,
                buyButtonsParent
            );

            wrapper.appendChild(qty);
            wrapper.appendChild(buyButtonsParent);
        }
    }

    return true;
}

// Run immediately if DOM is ready
document.addEventListener('DOMContentLoaded', moveQtyAndButton);

// Retry for dynamically loaded Shopify sections/apps
let retryCount = 0;
const interval = setInterval(() => {
    if (moveQtyAndButton() || retryCount >= 20) {
        clearInterval(interval);
    }
    retryCount++;
}, 500);

// Shopify Theme Editor support
document.addEventListener('shopify:section:load', moveQtyAndButton);

})();

